module.exports = __webpack_public_path__ + "img/13.8ff53a0f.png";